import { useTranslations } from 'next-intl';
import React, { FC } from 'react';
import { cn } from '@wwe-portal/ui/lib/lib';
import { TopDownConfetti } from '@wwe-portal/ui/effects/cofettie/topdown-cofettie';

export const NextQuestionTransition: FC<{
  questionIndex: number;
  numberOfQuestions: number;
}> = ({ questionIndex, numberOfQuestions }) => {
  const t = useTranslations();
  const lastQuestion = questionIndex + 1 >= numberOfQuestions;
  return (
    <div className="trivia-rumble-game-test_question-block bg-bgColor15 text-text400 relative flex flex-col items-center justify-center rounded-[10px] p-5 md:p-[30px]">
      {lastQuestion ? (
        <TopDownConfetti className="absolute inset-0 h-full w-full" />
      ) : null}
      <h5 className="text-md text-text400">{t('question')}</h5>
      <p
        className={cn(
          'trivia-rumble-game-test_question-block-next text-text300 text-5xl font-bold',
          {
            'text-deepSkyBlue': lastQuestion,
          }
        )}
      >
        {lastQuestion
          ? 'Final'
          : `${questionIndex + 1} ${t('of')} ${numberOfQuestions}`}
      </p>
    </div>
  );
};
